var exports = {
  "n": "x31de4314--6fc082--link",
  "G": "x31de4314--6fc082--typed",
};

module.exports = exports;
